import { NAME } from './constants';
import { router } from './router';

export const WmsVasSupervisor = {
	name: NAME,
	router,
};
